import React from 'react';

const HeaderSpacer = () => {
  return <div style={{ height: '103px', background: '#f0f0f2' }} />;
};

export default HeaderSpacer;



// WEBPACK FOOTER //
// ./src/components/header/header-spacer/index.js